// extracted by mini-css-extract-plugin
module.exports = {"magazineAdvertContainer":"Advert_magazineAdvertContainer__8TXN7","noPadding":"Advert_noPadding___pnf7","reportAdvert":"Advert_reportAdvert__VOfPQ"};